import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { EditorModule } from '@progress/kendo-angular-editor';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ColDef } from 'ag-grid-community';
import { CommonService } from '../../../question/services/commonservice';
import { SectionService } from '../../services/sectionservice';
import { questionLanguageSetting } from '../../models/questionLanguageSetting.model';
import { language } from '../../models/language.model';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'surveysectionlanguagesettings',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, EditorModule, IsgGridComponent, DropDownsModule],
  templateUrl: './page-survey-section-language-settings.component.html',
  styleUrl: './page-survey-section-language-settings.component.scss',
  providers: [CommonService, SectionService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageSurveySectionLanguageSettingsComponent extends BaseHttpReqRespService implements OnInit {

  public questionLanguageSettingsList: questionLanguageSetting[] = [];
  public languageList: language[] = [];
  public successOrFailureMessage: string = '';
  public sectionId!: number;
  public currentDeletingMappingId!: number;
  public sectionLanguageForm!: FormGroup;
  public isAgreeDisagreedisabled: boolean = false;
  public isDisabled: boolean = false;
  public sectionName!: string;
  public mappingId: number = 0;
  public selectedTempData: any;
  public currentQuestionid: any;
  public myAppUrl: any;

  @ViewChild('deleteLanguageModal') deleteLanguageModal!: TemplateRef<any>;
  modalRef: any;

  constructor(
    http: HttpClient,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private EncrDecr: EncrDecrService,
    private sectionService: SectionService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    public modalService: NgbModal,
    @Inject('BASE_URL') baseUrl: string
  ) {
    console.log('constructor loded');
    super(http, oauth);
    this.myAppUrl = baseUrl;
  }

  ngOnInit() {
    debugger;
    this.route.queryParams.subscribe(params => {
      this.sectionId = +params['sectionId'];
      this.getSectionDetails(this.sectionId);
      this.getLanguageList();
      this.getAllSurveySectionLanguageList();
    });

    this.sectionLanguageForm = this.formBuilder.group({
      sectionId: [0],
      mappingId: [0],
      questionId: [0],
      entityId: [0],
      entityTypeText: [''],
      languageId: [0, Validators.required],
      languageText: ['', Validators.required],
      sectionName: [''],
      sectionLanguageId: [''],
      sectionDescription: ['', [Validators.required,this.kendoEditorRequired]]
    });
  }

  kendoEditorRequired(control: FormControl) {
    const value = (control.value || '').replace(/<[^>]*>/g, '').trim();
    return value.length > 0 ? null : { required: true };
  }

  getSectionDetails(sectionId: number) {
    debugger;
    this.sectionService.getSectionDetails(sectionId).subscribe(response => {
      this.sectionName = response.sectionName;
      this.isAgreeDisagreedisabled = !!response.confirmation;
      this.sectionLanguageForm.patchValue({
        sectionName: response.sectionName
      });
    });
  }

  backUrl() {
    this._router.navigate(['/section']);
  }

  getLanguageList() {
    debugger;
    this.sectionService.getLanguageList().subscribe(data => {
      this.languageList = data;
      console.log(this.languageList);
    });
  }

  getAllSurveySectionLanguageList() {
    debugger;
    this.sectionService.getAllSurveySectionLanguageList(this.sectionId).subscribe(data => {
      this.questionLanguageSettingsList = data;
    });
  }

  checkDuplicateData() {
    const languageId = this.sectionLanguageForm.value.languageId;
    const sectionId = this.sectionId;
    return this.questionLanguageSettingsList.filter(x => x.languageId == languageId && x.entityId == sectionId);
  }

  saveSectionLanguage() {
    debugger;
    const duplicateValueLength = this.checkDuplicateData();
    if (duplicateValueLength.length === 0) {
      if (this.sectionLanguageForm.valid) {
        this.sectionLanguageForm.patchValue({
          mappingId: this.mappingId,
          questionId: 0,
          entityId: this.sectionId,
          entityTypeText: 'Informational Section',
          languageId: this.sectionLanguageForm.value.languageId,
          languageText: this.sectionLanguageForm.value.languageText
        });
        this.sectionService.saveSurveySectionLanguageSettings(this.sectionLanguageForm.value).subscribe(() => {
          this.mappingId = 0;
          this.sectionLanguageForm.reset();
          this.getSectionDetails(this.sectionId);
          this.getLanguageList();
          this.getAllSurveySectionLanguageList();
        });
      }
    } else {
      if (this.selectedTempData != null && this.selectedTempData.languageId == this.sectionLanguageForm.value.languageId) {
        this.mappingId = duplicateValueLength[0].mappingId;
        this.sectionLanguageForm.patchValue({
          mappingId: this.mappingId,
          questionId: 0,
          entityId: this.sectionId,
          entityTypeText: 'Informational Section',
          languageId: this.sectionLanguageForm.value.languageId,
          languageText: this.sectionLanguageForm.value.languageText
        });
        this.sectionService.saveSurveySectionLanguageSettings(this.sectionLanguageForm.value).subscribe(() => {
          this.mappingId = 0;
          this.sectionLanguageForm.reset();
          this.getSectionDetails(this.sectionId);
          this.getLanguageList();
          this.getAllSurveySectionLanguageList();
          this.isDisabled = true;
          alert("Updated Successfully");
        });
      } else {
        alert("Section language already exist.");
      }
    }
  }

  openDeleteLanguageModal(mappingId: number, questionId: number, modal: any) {
    this.currentDeletingMappingId = mappingId;
    this.currentQuestionid = questionId;
    this.modalRef = modal.open(this.deleteLanguageModal, {
      backdrop: 'static',
      keyboard: false
    });
  }

  deleteSurveyMappingId() {
    debugger;
    this.sectionService.deleteSurveySectionLanguageMapping(this.currentQuestionid, this.currentDeletingMappingId).subscribe(result => {
      this.questionLanguageSettingsList = result;
      this.getSectionDetails(this.sectionId);
      this.getLanguageList();
      this.getAllSurveySectionLanguageList();
      if (this.modalRef) {
        this.modalRef.close();
      }
    });
  }

  gridConfig: Partial<IsgGridConfig> = {
    height: '500px',
    pagination: true,
    pageSize: 10,
    autoSizeColumns: true
  };

  // Grid column definitions and renderers
  columnDefs: ColDef[] = [
    {
      headerName: 'Section Name',
      field: 'sectionName',
      resizable: true,
      cellRenderer: this.sectionNameRenderer.bind(this)
    },
    {
      headerName: 'Language',
      field: 'languageText',
      resizable: true
    },
    {
      headerName: 'Edit',
      cellRenderer: this.editRenderer.bind(this),
      width: 80,
      resizable: true
    },
    {
      headerName: 'Preview',
      cellRenderer: this.previewRenderer.bind(this),
      width: 80,
      resizable: true
    },
    {
      headerName: 'Delete',
      cellRenderer: this.deleteRenderer.bind(this),
      width: 80,
      resizable: true
    }
  ];

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

  sectionNameRenderer(params: any) {
    const element = this.renderer.createElement('span');
    const text = this.renderer.createText(params.value);
    this.renderer.appendChild(element, text);
    return element;
  }

  editRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-edit anchor-cursor');
    this.renderer.appendChild(element, icon);
    this.renderer.listen(element, 'click', () => {
      this.fillSectionDetails(params.data);
      return true;
    });
    return element;
  }

  fillSectionDetails(obj: any) {
    this.sectionLanguageForm.patchValue({
      languageId: obj.languageId,
      languageText: obj.languageText
    });
    this.mappingId = obj.mappingId;
    this.selectedTempData = obj;
    this.isDisabled = false;
  }

  previewRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-eye anchor-cursor');
    this.renderer.appendChild(element, icon);
    this.renderer.listen(element, 'click', () => {
      this.previewSectionDetails(params.data);
      return true;
    });
    return element;
  }

  previewSectionDetails(obj: any) {
    this.sectionLanguageForm.patchValue({
      languageId: obj.languageId,
      languageText: obj.languageText
    });
    this.mappingId = obj.mappingId;
    this.selectedTempData = obj;
    this.isDisabled = true;
  }

  deleteRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const icon = this.renderer.createElement('i');
    icon.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, icon);
    this.renderer.listen(element, 'click', () => {
      this.currentDeletingMappingId = params.data.mappingId;
      this.currentQuestionid = params.data.questionId;
      // You can open a modal here if needed
      this.deleteSurveyMappingId();
      return true;
    });
    return element;
  }
}















